import { render, staticRenderFns } from "./OrdersFBMEditing.vue?vue&type=template&id=2fc33606&scoped=true"
import script from "./OrdersFBMEditing.vue?vue&type=script&lang=js"
export * from "./OrdersFBMEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc33606",
  null
  
)

export default component.exports